import { jsx as i } from "react/jsx-runtime";
import n, { css as e } from "styled-components";
import l from "../../../icons/error.js";
import m from "../../../icons/info.js";
import s from "../../../icons/success.js";
import f from "../../../icons/warning.js";
import "../../../theme/themes/AtriusDark.js";
import "../../../theme/themes/AtriusLight.js";
import "../../../theme/themes/DistechDark.js";
import "../../../theme/themes/DistechLight.js";
import "../../../theme/themes/DLNLight.js";
import "../../../theme/utils/getThemeDefinition.js";
import { flavors as t } from "../../../theme/utils/styleUtils.js";
import "../../../theme/GlobalStyle.js";
import "react";
import "@emotion/is-prop-valid";
import "@mui/material/styles";
import "lodash/merge";
import "color-convert";
const c = e([
  "width:16px;height:16px;"
]), p = n(m).withConfig({
  displayName: "StyledInfoIcon"
})([
  "",
  " color:",
  ";"
], c, ({ theme: o }) => o.primaryFill), u = n(s).withConfig({
  displayName: "StyledSuccessIcon"
})([
  "",
  " color:",
  ";"
], c, ({ theme: o }) => o.good), d = n(f).withConfig({
  displayName: "StyledWarningIcon"
})([
  "",
  " color:",
  ";"
], c, ({ theme: o }) => o.metric), a = n(l).withConfig({
  displayName: "StyledErrorIcon"
})([
  "",
  " color:",
  ";"
], c, ({ theme: o }) => o.caution);
function A(o, r) {
  switch (r) {
    case "success":
      return o.good;
    case "warning":
      return o.metric;
    case "error":
      return o.caution;
    case "info":
    default:
      return o.primaryFill;
  }
}
function B(o) {
  let r = null;
  return o === "info" && (r = /* @__PURE__ */ i(p, {})), o === "success" && (r = /* @__PURE__ */ i(u, {})), o === "warning" && (r = /* @__PURE__ */ i(d, {})), o === "error" && (r = /* @__PURE__ */ i(a, {})), r;
}
function D(o) {
  let r = null;
  return o === "info" && (r = t.normal), o === "success" && (r = t.good), o === "warning" && (r = t.metric), o === "error" && (r = t.caution), r;
}
export {
  D as getFlavor,
  B as getIcon,
  A as getVariantColor
};
